import Store from 'types/Store/AvailabilityStore';

export const getAllPurchaseItems = (state: Store) =>
  state.availability.purchaseItems;

export const isFetching = (state: Store) => state.availability.isFetching;
